import { Box, Card, Flex, Text, Button } from '@mantine/core'
import React from 'react'

import type { IInsuranceCard } from './InsuranceCard.types'

const BookingInsurance = ({
  status,
  isLoading = false,
  button,
}: IInsuranceCard) => {
  return (
    <Card withBorder>
      <Flex justify='space-between' align='center' gap='sm'>
        {status.icon}
        <Box style={{ flex: 1 }}>
          <Text>{status.title}</Text>
          <Text size='sm' color='dimmed'>
            {status.description}
          </Text>
        </Box>
        <Button
          loading={isLoading}
          size='sm'
          variant='default'
          data-testid='view'
          {...button}
        />
      </Flex>
    </Card>
  )
}

export default BookingInsurance
